<template>
    <div class="modal fade show modal-style " aria-labelledby="cardTitle">
        <div class="modal-dialog modal-dialog-centered" ref="modalRef">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between px-1 my-1 align-items-center">
                            <h3 class="mb-0">Reserved Product Quantity</h3>
                            <button
                                @click="onClickClose"
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                    </div>
                </div>
                <hr class="mt-0 mb-0">
                <div class="py-2 px-4">
                    <div class="alert alert-danger p-2 border border-danger" v-if="errorMessage && errorMessage !== ''">
                        {{ errorMessage }}
                    </div>
                    <p class="text-danger">
                        This products are reserved against this form for an hour, if not needed please clear the form.
                    </p>
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th class="width-75-per">Product</th>
                                <th class="width-25-per">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="product in productList">
                                <td class="width-75-per">{{ product.text }}</td>
                                <td class="width-25-per text-center">
                                    <button
                                        class="btn btn-sm btn-outline-danger text-nowrap px-1 button_icon"
                                        type="button"
                                        @click="removeProductFromCache(product.product_id)"
                                    >
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="d-flex gap-2 justify-content-end pb-1 px-2">
                    <div class="d-flex justify-content-end">
                        <button class="btn btn-danger" type="button" @click="clearAll">Clear All</button>
                    </div>
                    <div class="d-flex justify-content-end">
                        <button class="btn btn-primary" type="button" @click="onCLickGo">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import {useStore} from "vuex";
    import {useRoute} from "vue-router";
    import {computed, ref} from "vue";
    import handlePurchase from "@/services/modules/purchase";

    const emit = defineEmits(['updateProductList']);
    const props = defineProps({
        productList : {
            default: [],
            type: Array
        }
    })
    const store = useStore();
    const route = useRoute();
    const formKey = computed(() => route.query.form_key)
    const { removeProductsFormKey } = handlePurchase();
    const errorMessage = ref('');

    const updateProductList = (productId = null) => {
        if (!productId) {
            return [];
        }

        return props.productList.filter((product) => {
            return product.product_id !== productId;
        });
    }

    const handleFormCleaning = (query, productId = null) => {
        errorMessage.value = '';
        removeProductsFormKey(formKey.value, query).then(() => {
            const list = updateProductList(productId)
            emit('updateProductList', list)
            list.length < 1 && onClickClose();
        }).catch(err => {
            if (err.response && err.response.data) {
                errorMessage.value = err.response.data.message;
            }
        })
    }

    const removeProductFromCache = (productId) => {
        const query = `?product_id=${productId}`;
        handleFormCleaning(query, productId);
    }

    const clearAll = () => {
        const query = `?is_delete_all=1`;
        handleFormCleaning(query);
    }

    const onClickClose = () => {
        store.state.isModalOpen = false;
    }


    const onCLickGo = () => {
        onClickClose();
    }

</script>

<style scoped>
.modal-style {
    display: block;
    background: #1c1d1c33
}
</style>